import { Link } from '@change/ds-core-ui/Link';
import { Text } from '@change/ds-core-ui/Text';

import { useTracking } from '../../../hooks/useTracking';

export type NameProps = {
	publiclyVisible: boolean;
	slug: string | null;
	id: string;
	displayName: string;
};

export const Name: React.FC<NameProps> = ({ displayName, id, publiclyVisible, slug }) => {
	const { trackDMProfileClick } = useTracking();
	return (
		<>
			{publiclyVisible ? (
				<Link
					variant="secondary"
					bold
					data-qa="dm-link"
					href={`/decision-makers/${slug || id}?source_location=petition_details`}
					onClick={() => trackDMProfileClick(id)}
				>
					<Text variant="heading" size="x-small">
						{displayName}
					</Text>
				</Link>
			) : (
				<Text variant="heading" size="x-small">
					{displayName}
				</Text>
			)}
		</>
	);
};
